import { render, staticRenderFns } from "./WorkflowReferenceTab.vue?vue&type=template&id=37e07ac2&scoped=true&"
import script from "./WorkflowReferenceTab.vue?vue&type=script&lang=ts&"
export * from "./WorkflowReferenceTab.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowReferenceTab.vue?vue&type=style&index=0&id=37e07ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e07ac2",
  null
  
)

export default component.exports